export default __webpack_public_path__ + "static/media/Ame.0f5f1ca8.svg";